import React from "react";
import RegisterPage from "../components/RegisterPage";
import { useHSE } from "../lib/store";

const SEV = {
  Minor: { bg: "#DCFCE7", color: "#166534" },
  Major: { bg: "#FEF3C7", color: "#854D0E" },
  Critical: { bg: "#FEE2E2", color: "#7F1D1D" },
};
const STATUS = {
  Open: { bg: "#FEF3C7", color: "#854D0E" },
  "In Progress": { bg: "#DBEAFE", color: "#1E40AF" },
  Closed: { bg: "#DCFCE7", color: "#166534" },
  Overdue: { bg: "#FEE2E2", color: "#7F1D1D" },
};

export default function NCRRegister() {
  const { data, siteNames } = useHSE();
  const open = data.ncrs.filter((n) => n.status === "Open" || n.status === "In Progress").length;
  const closed = data.ncrs.filter((n) => n.status === "Closed").length;
  const overdue = data.ncrs.filter((n) => n.status === "Overdue").length;

  const Top = (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
      <Stat label="Total" value={data.ncrs.length} />
      <Stat label="Open" value={open} tone="warning" />
      <Stat label="Closed" value={closed} tone="safe" />
      <Stat label="Overdue" value={overdue} tone="critical" />
    </div>
  );

  return (
    <RegisterPage
      title="Incident Statistics"
      subtitle="Non-compliance, property damage, fire/explosion and corrective case tracking"
      storeKey="ncrs"
      idPrefix="NCR"
      topPanels={Top}
      columns={[
        { key: "id", label: "NCR ID" },
        { key: "dateReceived", label: "Received" },
        { key: "site", label: "Site" },
        { key: "department", label: "Dept" },
        { key: "source", label: "Source" },
        { key: "category", label: "Category" },
        { key: "severity", label: "Severity" },
        { key: "responsible", label: "Responsible" },
        { key: "dueDate", label: "Due" },
        { key: "status", label: "Status" },
      ]}
      badgeMap={{ severity: SEV, status: STATUS }}
      formFields={[
        { key: "id", label: "NCR ID" },
        { key: "dateReceived", label: "Date Received", type: "date" },
        { key: "site", label: "Site", type: "select", options: siteNames },
        { key: "department", label: "Department", type: "select", options: data.settings.departments },
        { key: "source", label: "Source", type: "select", options: ["Internal Audit", "External Audit", "Client", "Consultant"] },
        { key: "description", label: "Description", type: "textarea", full: true },
        { key: "category", label: "Category", type: "select", options: ["Quality", "Process", "Documentation", "Safety", "Environmental"] },
        { key: "severity", label: "Severity", type: "select", options: ["Minor", "Major", "Critical"] },
        { key: "responsible", label: "Responsible" },
        { key: "correctiveAction", label: "Corrective Action", type: "textarea", full: true },
        { key: "dueDate", label: "Due Date", type: "date" },
        { key: "closureDate", label: "Closure Date", type: "date" },
        { key: "status", label: "Status", type: "select", options: ["Open", "In Progress", "Closed", "Overdue"] },
      ]}
    />
  );
}

function Stat({ label, value, tone = "neutral" }) {
  const c = { safe: "#54A57B", warning: "#FFB517", critical: "#DC2626", neutral: "#183C55" }[tone];
  return (
    <div className="command-card p-3.5 border-l-4" style={{ borderLeftColor: c }}>
      <div className="text-[10px] uppercase tracking-wider text-slate-500 font-semibold">{label}</div>
      <div className="font-heading font-bold text-2xl tabular text-[#0E2336] mt-0.5">{value}</div>
    </div>
  );
}
